import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';

const useTaskFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    nameUniqueId: yup.string().required(t('general.field.validation.required')),
    description: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(255, t('general.field.validation.maxCharacters').replace('{0}', '255'))
      .trim(),
  });
  return { schema };
};
export default useTaskFormSchema;
